import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-74f36636")

_pushScopeId("data-v-74f36636")
const _hoisted_1 = { class: "application" }
const _hoisted_2 = { class: "content_ls_margin" }
const _hoisted_3 = { class: "ls-slate-dark" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", null, "As LSNSW staff member you can skip this page to the next step.", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createVNode("h3", null, "Please outline your expertise/practice areas/activities/experience directly relevant to the committees you have applied for. Where you have previously served, or are currently on, one of these committees, please set out your contribution to the work of that committee * ", -1)
const _hoisted_11 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-exclamation-circle" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("h3", null, "Why do you wish to join your nominated committee(s)? *", -1)
const _hoisted_17 = {
  key: 1,
  class: "validation-msg ma-1"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fa fa-exclamation-circle" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("h3", null, "Please list any publications/articles you have authored/contributed to in the last two years, relevant to the committee(s) you are applying for. *", -1)
const _hoisted_23 = {
  key: 2,
  class: "validation-msg ma-1"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fa fa-exclamation-circle" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("h3", null, "Please let us know if you have any suggestions for us to improve the committee application process. (optional)", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("small", { class: "ml-3 ls-slate-light" }, " * Denotes mandatory field ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.pageHeader), 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      (_ctx.isLsNswStaff)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLsNswStaff)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("p", null, _toDisplayString(_ctx.maxLength) + " characters only. ", 1),
            _withDirectives(_createVNode("textarea", {
              ref: "textarea1",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.eoi.response1 = $event)),
              onKeyup: _cache[2] || (_cache[2] = $event => (_ctx.textCount(1))),
              maxlength: "3000",
              onkeyup: "this.style.height= '120px'; this.style.height = this.scrollHeight + 16 + 'px';"
            }, "\n    ", 544), [
              [
                _vModelText,
                _ctx.eoi.response1,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode("p", {
              class: _ctx.textCount1 > _ctx.maxLength ? 'small error' : 'small'
            }, _toDisplayString(_ctx.textCount1) + "/" + _toDisplayString(_ctx.maxLength) + " characters", 3),
            (_ctx.eoi.response1 === '')
              ? (_openBlock(), _createBlock("span", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13
                ]))
              : _createCommentVNode("", true),
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _createVNode("p", null, _toDisplayString(_ctx.maxLength) + " characters only. ", 1),
            _withDirectives(_createVNode("textarea", {
              ref: "textarea2",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.eoi.response2 = $event)),
              onKeyup: _cache[4] || (_cache[4] = $event => (_ctx.textCount(2))),
              maxlength: "3000",
              onkeyup: "this.style.height='120px'; this.style.height = this.scrollHeight + 16 + 'px';"
            }, "\n    ", 544), [
              [
                _vModelText,
                _ctx.eoi.response2,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode("p", {
              class: _ctx.textCount2 > _ctx.maxLength ? 'small error' : 'small'
            }, _toDisplayString(_ctx.textCount2) + "/" + _toDisplayString(_ctx.maxLength) + " characters", 3),
            (_ctx.eoi.response2 === '')
              ? (_openBlock(), _createBlock("span", _hoisted_17, [
                  _hoisted_18,
                  _hoisted_19
                ]))
              : _createCommentVNode("", true),
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _createVNode("p", null, _toDisplayString(_ctx.maxLength) + " characters only. ", 1),
            _withDirectives(_createVNode("textarea", {
              ref: "textarea3",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.eoi.response3 = $event)),
              onKeyup: _cache[6] || (_cache[6] = $event => (_ctx.textCount(3))),
              maxlength: "3000",
              onkeyup: "this.style.height='120px'; this.style.height = this.scrollHeight + 16 + 'px';"
            }, "\n    ", 544), [
              [
                _vModelText,
                _ctx.eoi.response3,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode("p", {
              class: _ctx.textCount3 > _ctx.maxLength ? 'small error' : 'small'
            }, _toDisplayString(_ctx.textCount3) + "/" + _toDisplayString(_ctx.maxLength) + " characters", 3),
            (_ctx.eoi.response3 === '')
              ? (_openBlock(), _createBlock("span", _hoisted_23, [
                  _hoisted_24,
                  _hoisted_25
                ]))
              : _createCommentVNode("", true),
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _createVNode("p", null, _toDisplayString(_ctx.maxLength) + " characters only. ", 1),
            _withDirectives(_createVNode("textarea", {
              ref: "textarea4",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.eoi.response4 = $event)),
              onKeyup: _cache[8] || (_cache[8] = $event => (_ctx.textCount(4))),
              maxlength: "3000",
              onkeyup: "this.style.height='120px'; this.style.height = this.scrollHeight + 16 + 'px';"
            }, "\n      ", 544), [
              [
                _vModelText,
                _ctx.eoi.response4,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode("p", {
              class: _ctx.textCount4 > _ctx.maxLength ? 'small error' : 'small'
            }, _toDisplayString(_ctx.textCount4) + "/" + _toDisplayString(_ctx.maxLength) + " characters", 3)
          ]))
        : _createCommentVNode("", true),
      _hoisted_29,
      _hoisted_30,
      _hoisted_31
    ])
  ]))
})